const user_details = {
    page_title: 'جزئیات کاربر',
    back_to_users: 'بازگشت به مدیریت کاربران',
    created_title: 'این کاربر با موفقیت ایجاد شد',
    created_guide: 'اطلاعات زیر برای کمک به فرایند ورود کاربر است.',
    created_email: 'آدرس ایمیل:',
    created_phone: 'شماره تلفن:',
    created_username: 'نام کاربری:',
    created_password: 'رمز عبور:',
    menu_delete: 'حذف',
    delete_description: 'این عمل قابل بازگشت نیست. کاربر برای همیشه حذف می‌شود.',
    deleted: 'کاربر با موفقیت حذف شد',
    reset_password: {
        reset_title: 'آیا مطمئن هستید که می‌خواهید رمز عبور را بازنشانی کنید؟',
        generate_title: 'آیا مطمئن هستید که می‌خواهید رمز عبور تولید کنید؟',
        content: 'این عمل قابل بازگشت نیست. اطلاعات ورود کاربر به‌روزرسانی می‌شود.',
        reset_complete: 'رمز عبور بازنشانی شد',
        generate_complete: 'رمز عبور تولید شد',
        new_password: 'رمز عبور جدید:',
        password: 'رمز عبور:',
    },
    expire_password: {
        button: 'انقضا',
        title: 'آیا مطمئن هستید که می‌خواهید این رمز عبور را منقضی کنید؟',
        content: 'کاربر باید در ورود بعدی رمز عبور را بازنشانی کند. این عمل قابل بازگشت نیست.',
        success: 'رمز عبور کاربر به‌عنوان منقضی‌شده علامت‌گذاری شد.',
        not_enabled_tooltip: 'سیاست انقضای رمز عبور فعال نیست.',
    },
    tab_settings: 'تنظیمات',
    tab_roles: 'نقش‌ها',
    tab_logs: 'گزارش‌های کاربر',
    tab_organizations: 'سازمان‌ها',
    authentication: 'احراز هویت',
    authentication_description: 'هر کاربر پروفایلی دارد که شامل همه اطلاعات کاربر است. این شامل داده‌های پایه، هویت‌های اجتماعی و داده‌های سفارشی است.',
    user_profile: 'داده کاربر',
    field_email: 'آدرس ایمیل',
    field_phone: 'شماره تلفن',
    field_username: 'نام کاربری',
    field_password: 'رمز عبور',
    field_name: 'نام',
    field_avatar: 'URL تصویر آواتار',
    field_avatar_placeholder: 'https://your.cdn.domain/avatar.png',
    field_custom_data: 'داده سفارشی',
    field_custom_data_tip: 'اطلاعات کاربر اضافی که در ویژگی‌های ازپیش‌تعریف‌شده کاربر نیست، مانند رنگ و زبان ترجیحی کاربر.',
    field_profile: 'پروفایل',
    field_profile_tip: 'ادعاهای استاندارد OpenID Connect اضافی که در ویژگی‌های کاربر نیستند. توجه: همه ویژگی‌های ناشناخته حذف می‌شوند. برای اطلاعات بیشتر به <a>مرجع ویژگی پروفایل</a> مراجعه کنید.',
    field_connectors: 'اتصالات اجتماعی',
    field_sso_connectors: 'اتصالات سازمانی',
    custom_data_invalid: 'داده سفارشی باید یک شیء JSON معتبر باشد',
    profile_invalid: 'پروفایل باید یک شیء JSON معتبر باشد',
    password_already_set: 'رمز عبور از قبل تنظیم شده است',
    no_password_set: 'رمز عبور تنظیم نشده است',
    connectors: {
        connectors: 'اتصال‌دهنده‌ها',
        user_id: 'شناسه کاربر',
        remove: 'حذف',
        connected: 'این کاربر به چند اتصال‌دهنده اجتماعی متصل است.',
        not_connected: 'کاربر به هیچ اتصال‌دهنده اجتماعی متصل نیست',
        deletion_confirmation: 'در حال حذف هویت موجود <name/> هستید. آیا مطمئن هستید که می‌خواهید ادامه دهید؟',
    },
    sso_connectors: {
        connectors: 'اتصال‌دهنده‌ها',
        enterprise_id: 'شناسه سازمان',
        connected: 'این کاربر به چند ارائه‌دهنده هویت سازمانی برای ورود یکپارچه متصل است.',
        not_connected: 'کاربر به هیچ ارائه‌دهنده هویت سازمانی برای ورود یکپارچه متصل نیست.',
    },
    mfa: {
        field_name: 'احراز هویت چندعاملی',
        field_description: 'این کاربر عوامل تأیید دو مرحله‌ای را فعال کرده است.',
        name_column: 'چندعاملی',
        field_description_empty: 'این کاربر عوامل تأیید دو مرحله‌ای را فعال نکرده است.',
        deletion_confirmation: 'در حال حذف <name/> موجود برای تأیید دو مرحله‌ای هستید. آیا مطمئن هستید که می‌خواهید ادامه دهید؟',
    },
    passkey: {
        field_name: 'Passkeyها',
        field_description_empty: 'این کاربر ورود با passkey را فعال نکرده است.',
        deletion_confirmation: 'در حال حذف <name/> موجود برای ورود با passkey هستید. آیا مطمئن هستید که می‌خواهید ادامه دهید؟',
    },
    suspended: 'معلق',
    suspend_user: 'تعلیق کاربر',
    suspend_user_reminder: 'آیا مطمئن هستید که می‌خواهید این کاربر را تعلیق کنید؟ کاربر نمی‌تواند به برنامه شما وارد شود و پس از انقضای توکن فعلی نمی‌تواند توکن دسترسی جدید دریافت کند. همچنین هر درخواست API این کاربر ناموفق خواهد بود.',
    suspend_action: 'تعلیق',
    user_suspended: 'کاربر تعلیق شد.',
    reactivate_user: 'فعال‌سازی مجدد کاربر',
    reactivate_user_reminder: 'آیا مطمئن هستید که می‌خواهید این کاربر را دوباره فعال کنید؟ این کار اجازه هر تلاش ورود برای این کاربر را می‌دهد.',
    reactivate_action: 'فعال‌سازی مجدد',
    user_reactivated: 'کاربر دوباره فعال شد.',
    roles: {
        name_column: 'نقش کاربر',
        description_column: 'توضیحات',
        assign_button: 'اختصاص نقش‌ها',
        delete_description: 'این عمل این نقش را از این کاربر حذف می‌کند. خود نقش همچنان وجود دارد اما دیگر به این کاربر مرتبط نیست.',
        deleted: '{{name}} با موفقیت از این کاربر حذف شد.',
        assign_title: 'اختصاص نقش‌ها به {{name}}',
        assign_subtitle: 'نقش‌های کاربر مناسب را با جستجوی نام، توضیحات یا شناسه نقش پیدا کنید.',
        assign_role_field: 'اختصاص نقش‌ها',
        role_search_placeholder: 'جستجو بر اساس نام نقش',
        added_text: '{{value, number}} اضافه شد',
        assigned_user_count: '{{value, number}} کاربر',
        confirm_assign: 'اختصاص نقش‌ها',
        role_assigned: 'نقش(ها) با موفقیت اختصاص یافت',
        search: 'جستجو بر اساس نام نقش، توضیحات یا شناسه',
        empty: 'نقشی در دسترس نیست',
    },
    warning_no_sign_in_identifier: 'کاربر باید حداقل یکی از شناسه‌های ورود (نام کاربری، ایمیل، تلفن یا اجتماعی) را داشته باشد تا وارد شود. آیا مطمئن هستید که می‌خواهید ادامه دهید؟',
    personal_access_tokens: {
        title: 'توکن دسترسی شخصی',
        title_other: 'توکن‌های دسترسی شخصی',
        title_short: 'توکن',
        empty: 'کاربر هیچ توکن دسترسی شخصی ندارد.',
        create: 'ایجاد توکن جدید',
        tip: 'توکن‌های دسترسی شخصی (PAT) راهی امن برای اعطای توکن دسترسی بدون استفاده از اعتبارنامه و ورود تعاملی فراهم می‌کنند. برای CI/CD، اسکریپت‌ها یا برنامه‌هایی که به‌صورت برنامه‌ای به منابع دسترسی نیاز دارند مفید است.',
        value: 'مقدار',
        created_at: 'ایجاد شده در',
        expires_at: 'انقضا در',
        never: 'هرگز',
        create_new_token: 'ایجاد توکن جدید',
        delete_confirmation: 'این عمل قابل بازگشت نیست. آیا مطمئن هستید که می‌خواهید این توکن را حذف کنید؟',
        expired: 'منقضی‌شده',
        expired_tooltip: 'این توکن در {{date}} منقضی شد.',
        create_modal: {
            title: 'ایجاد توکن دسترسی شخصی',
            expiration: 'انقضا',
            expiration_description: 'توکن در {{date}} منقضی می‌شود.',
            expiration_description_never: 'توکن هرگز منقضی نمی‌شود. برای امنیت بیشتر تاریخ انقضا تنظیم کنید.',
            days: '{{count}} روز',
            days_other: '{{count}} روز',
            created: 'توکن {{name}} با موفقیت ایجاد شد.',
        },
        edit_modal: {
            title: 'ویرایش توکن دسترسی شخصی',
            edited: 'توکن {{name}} با موفقیت ویرایش شد.',
        },
    },
    sessions: {
        title: 'نشست‌ها',
        description: 'نشست‌های نگهداری‌شده توسط سرور مجوز Logto را مدیریت کنید. لغو نشست Logto در اینجا از رضایت خودکار در درخواست‌های مجوز بعدی جلوگیری می‌کند.',
        field_name: 'نشست‌ها',
        multiple_signed_in: 'این کاربر در چند دستگاه یا مرورگر وارد شده است.',
        not_found: 'هیچ نشست فعال Logto یافت نشد. کاربر فعلاً در هیچ دستگاهی وارد نشده است.',
        name_column: 'نام',
        session_id_column: 'شناسه نشست',
        location_column: 'مکان',
        browser_on_os: '{{browser}} در {{os}}',
        user: 'کاربر',
        applications: 'برنامه‌ها',
        signed_in_at: 'آخرین ورود',
        ip: 'IP',
        browser_name: 'نام مرورگر',
        os_name: 'نام سیستم‌عامل',
        device_model: 'مدل دستگاه',
        revoke_session: 'لغو نشست',
        revoke_session_confirmation: 'اگر این نشست را حذف کنید، کاربران مجبور به احراز هویت مجدد می‌شوند.',
    },
    third_party_apps: {
        title: 'برنامه‌های شخص ثالث',
        description: 'از Logto به‌عنوان ارائه‌دهنده هویت برای مجاز کردن برنامه‌های شخص ثالث استفاده کنید. برنامه‌هایی که این کاربر دسترسی داده را مشاهده و مدیریت کنید.',
        field_name: 'برنامه‌های شخص ثالث مجاز',
        multiple_authorized: 'این کاربر به چند برنامه و سرویس شخص ثالث دسترسی داده است.',
        not_authorized: 'این کاربر هنوز به هیچ برنامه یا سرویس شخص ثالثی دسترسی نداده است.',
        name_column: 'نام',
        app_id_column: 'شناسه برنامه',
        access_created_at_column: 'دسترسی ایجاد شده در',
        revoke_access_title: 'لغو دسترسی؟',
        revoke_access_description: 'این کار دسترسی برنامه به حساب این کاربر در همه دستگاه‌ها را لغو می‌کند. کاربر باید دوباره مجاز کند تا دسترسی بازیابی شود.',
    },
    connections: {
        title: 'اتصال',
        description: 'کاربر حساب‌های شخص ثالث را برای ورود اجتماعی، SSO سازمانی یا دسترسی به منابع متصل می‌کند.',
        token_status_column: 'وضعیت توکن',
        token_status: {
            active: 'فعال',
            expired: 'منقضی‌شده',
            inactive: 'غیرفعال',
            not_applicable: 'قابل اعمال نیست',
            available: 'در دسترس',
            not_available: 'در دسترس نیست',
        },
    },
};
export default Object.freeze(user_details);
